import React, { useEffect, useState } from "react";
import ClearSearch from "../../clear-search";
import { ProductItemInterface } from "../../../assets/interfaces";
import useStoreItemsPagination from "../../hooks/useStoreItemsManager";
import Router from "next/router";
import ProductItem from "../items/product-item";
import ProductItemLoader from "../items/product-item-loader";
import { EmptyItems } from "../ui/errors";

interface Props {
  productsLoading: boolean;
  items: { main?: ProductItemInterface[]; featured?: ProductItemInterface[] };
  search?: string;
  currentPage: number;
  pagData: { next_page: number | null; prev_page: number | null; total_pages: number | null };
  goNext: () => void;
  setSelectedItem: (item: ProductItemInterface) => void;
  isLoading: boolean;
  resetPage: () => void;
  store?: string;
  showFeatured?: boolean;
  emptyItemsCount?: number;
}

const ItemsGridView: React.FC<Props> = ({
  productsLoading,
  items,
  search,
  currentPage,
  pagData,
  goNext,
  setSelectedItem,
  isLoading,
  resetPage,
  store,
  showFeatured = true,
  emptyItemsCount = 10,
}) => {
  useStoreItemsPagination({ currentPage, pagData, isLoading, goNext });
  const { main, featured } = items;
  return (
    <div className="mt-5">
      <ClearSearch search={search} onClear={resetPage} />
      {showFeatured && (
        <div className="pb-7.5 mb-7.5 sm:pb-3 sm:mb-7.5 lg:pb-4.5 lg:mb-7 border-opacity-50">
          <div className="flex justify-between items-center  mb-5 sm:mb-4.5 lg:mb-5">
            <h3 className="text-black text-lg sm:text-xl md:text-xl font-bold flex items-center">Featured Items</h3>
            <button
              onClick={() => Router.push(`${store}/products`)}
              className="gap-1.5 items-center text-sm sm:text-1sm font-display font-semibold md:text-base flex text-primary-500"
            >
              All Products
              {/* prettier-ignore */}
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" >
                <path d="M3.75 9H14.25M14.25 9L9 3.75M14.25 9L9 14.25" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-6 sm:gap-7.5  lg:gap-10">
            {featured && featured?.length > 0
              ? featured.map((item, index) => (
                  <ProductItem index={index} key={item.id} openItem={() => setSelectedItem(item)} item={item} />
                ))
              : Array.from(Array(8).keys()).map((_, index) => <ProductItemLoader key={index} />)}
          </div>
        </div>
      )}

      {main && (
        <ItemsGridList
          items={main}
          productsLoading={productsLoading}
          setSelectedItem={setSelectedItem}
          emptyItemsCount={emptyItemsCount}
        />
      )}
    </div>
  );
};

interface ItemsGridListProps {
  items: ProductItemInterface[];
  productsLoading: boolean;
  setSelectedItem: (item: ProductItemInterface) => void;
  emptyItemsCount: number;
}

export const ItemsGridList: React.FC<ItemsGridListProps> = ({
  items,
  productsLoading,
  setSelectedItem,
  emptyItemsCount,
}) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-2 sm:grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-6 sm:gap-7.5  lg:gap-10">
        {items.map((item, index) => (
          <ProductItem index={index} key={item.id} openItem={() => setSelectedItem(item)} item={item} />
        ))}

        {productsLoading &&
          Array.from(Array(emptyItemsCount).keys()).map((_, index) => <ProductItemLoader key={index} />)}

        {!productsLoading && items.length < 1 && (
          <div className="col-span-full">
            <EmptyItems />
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemsGridView;
